<template>
	<transition name="v-slide">
		<div id="formWrapper" v-if="show" class="modal fade show" :style="{ display: show ? 'block' : 'none' }" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="false">
			<div class="modal-dialog align-items-end modal-dialog-center">
				<div class="modal-content">
					<button @click="show = false" type="button" class="close position-absolute" style="right: 20px; top: 15px" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="false">&times;</span>
					</button>
					<div class="modal-body text-center">
						<div id="lead-photo">
							<img :src="user.external_profile_first ? user.external_profile_first_path : '/assets/img/icons/profile.jpg'">
						</div>
						<div v-if="submitted">
							<p class="text-uppercase" style="font-size: 1.25rem">Success!</p>

							<div v-if="link" class="form-group">
								<a :href="link" target="_blank" class="btn btn-block btn-lead">Access Document</a>
							</div>
							<div class="form-group">
								<button @click="close" type="button" class="btn btn-block btn-lead">Close</button>
							</div>
							<div class="form-group">
								<p><a href="/register/retailuser" class="text-lead" target="_blank">Click here</a> to create your own LookBookLink.</p>
							</div>
							<div class="form-group">
								<p class="text-muted">LookBookLink does not share or sell your data.</p>
							</div>
						</div>
						<div v-else>
							<p style="font-size: 1.25rem">Share your info with {{ user.name }} <template v-if="gallery"> to access {{ gallery.title }}</template></p>
							<p v-if="gallery && gallery.caption">{{ gallery.caption }}</p>
							<form method="POST" action="">
								<div class="form-group">
									<input v-model="form.name" type="text" class="form-control" :class="getValidationClass('name')" name="name" placeholder="Name *">
									<div class="invalid-feedback" v-for="error of v$.form.name.$errors" :key="error.$uid">{{ error.$message }}</div>
								</div>
								<div class="form-group">
									<input v-model="form.email" type="email" class="form-control" :class="getValidationClass('email')" name="email" placeholder="Email *">
									<div class="invalid-feedback" v-for="error of v$.form.email.$errors" :key="error.$uid">{{ error.$message }}</div>
								</div>
								<div class="form-group">
									<input v-model="form.phone" type="text" class="form-control" :class="getValidationClass('phone')" name="phone" placeholder="Phone *">
									<div class="invalid-feedback" v-for="error of v$.form.phone.$errors" :key="error.$uid">{{ error.$message }}</div>
								</div>
								<div class="form-group">
									<input v-model="form.company" type="text" class="form-control" :class="getValidationClass('company')" name="company" placeholder="Company">
									<div class="invalid-feedback" v-for="error of v$.form.company.$errors" :key="error.$uid">{{ error.$message }}</div>
								</div>
								<div class="form-group">
									<textarea v-model="form.notes" class="form-control" name="notes" maxlength="10000" :class="getValidationClass('notes')" rows="2" placeholder="Notes"></textarea>
									<div class="invalid-feedback" v-for="error of v$.form.notes.$errors" :key="error.$uid">{{ error.$message }}</div>
								</div>
								<div class="form-group text-center" :class="getValidationClass('captcha')">
									<vue-recaptcha :sitekey="googleKey" size="normal" theme="light" :loading-timeout="loadingTimeout" @verify="recaptchaVerified" @expire="recaptchaExpired" ref="vueRecaptcha" style="display: inline-block;" />
									<div class="invalid-feedback" v-for="error of v$.form.captcha.$errors" :key="error.$uid">{{ error.$message }}</div>
								</div>
								<div class="form-group">
									<button @click="validateForm" type="button" class="btn btn-block btn-lead">{{ gallery ? 'Submit' : 'Send' }}</button>
								</div>
								<div class="form-group">
									<p class="text-muted">LookBookLink does not share or sell your data.</p>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
	import useVuelidate from '@vuelidate/core'
	import { required, requiredIf, email, minLength, helpers } from '@vuelidate/validators'
	import { get } from 'lodash';
	import emitter from 'tiny-emitter/instance'
	import vueRecaptcha from 'vue3-recaptcha2';
	export default {
		name: 'LeadForm',
		setup: () => ({ v$: useVuelidate() }),
		data() {
			return {
				show: false,
				submitted: false,
				isLoading: false,
				loadingTimeout: 30000,
				vuelidateExternalResults: {},
				form: {
					name: null,
					email: null,
					phone: null,
					company: null,
					notes: null,
					captcha: null,
					gallery_id: null,
				},
				gallery: null,
				link: null,
			}
		},
		props: {
			user: Object,
		},
		watch: {
			show(after) {
				if (after) {
  					document.body.style.overflowY = "hidden";
  				} else {
  					document.body.style.overflowY = null;		
  				}
  			}
  		},
		components: {
			vueRecaptcha
		},
		validations() {
			return {
				form: {
					name: {
						required: helpers.withMessage('The name field is required', required),
					},
					email: {
						required: helpers.withMessage('The email field is required', required),
						email: helpers.withMessage('Please enter a valid email', email),
					},
					phone: {
						required: helpers.withMessage('The phone field is required', required),
					},
					company: {
						nullable: (value) => true
					},
					notes: {
						nullable: (value) => true
					},
					captcha: {
						required: helpers.withMessage('The captcha field is required', required),
					}
				}
	        }
        },
        computed: {
        	googleKey() {
        		return process.env.MIX_RECAPTCHA_SITE_KEY;
        	}
        },
		created() {
			if (this.user.leads_enabled && this.user.leads_auto_popup) {
				setTimeout(() => {
					this.show = true;
				}, 2000);
			}
			emitter.on('leadForm', (data) => {
				if (data) {
					this.gallery = data;
					this.form.gallery_id = data.id;
					this.show = true;
				} else {
					this.show = !this.show;	
				}
			});
		},
		mounted() {
			const url = new URL(window.location.href);
			if (url.searchParams.has('form')) {
				this.show = true;
			}
		},
		methods: {
			close() {
				this.show = false;
				this.link = null;
			},
			recaptchaExpired() {
	  			this.$refs.vueRecaptcha.reset();
	  			this.form.captcha = null;
			},
			recaptchaVerified(response) {
				this.form.captcha = response;
			},
			getValidationClass(fieldName, object = 'form') {
	            const field = _.get(this.v$[object], fieldName);
	            if (field && !this.isLoading) {
	                return {
	                    'is-invalid': field.$error
	                }
	            }
	        },
	        async validateForm () {
	            this.v$.$clearExternalResults()
	            const isFormValid = await this.v$.form.$validate()
	            if (isFormValid) {
	                return this.saveData();
	            }
	        },
	        saveData() {
	        	this.isLoading = true;
	        	axios.post(`/${ this.user.name_slug }/lead`, this.form)
	        	.then(response => {
	        		this.isLoading = false;
	        		this.form = {
						name: null,
						email: null,
						phone: null,
						company: null,
						notes: null,
						captcha: null,
						gallery_id: null,
					},
					this.recaptchaExpired();
					this.v$.$reset();
					if (this.gallery) {
						try {
							var newWindow = window.open(this.gallery.href, '_blank');
							if (newWindow) {
								newWindow.focus();
							}
						} catch (error) {
						}
						this.link = this.gallery.href;
						window.hasSubmitted = true;
					}
					this.submitted = true;
					this.gallery = null;
	        	}).catch(error => {
	        		this.isLoading = false;
	        		if (error.response.status == 422 && error.response.data.errors) {
						Object.assign(this.vuelidateExternalResults, { form: error.response.data.errors })
						return;
					}
	        	});
	        },
		}
	}
</script>
<style scoped>
	.form-control {
		border-color: #404040;
	}
	.form-control::placeholder {
	    color: #404040;
	    opacity: 1;
	}
	.form-control:-ms-input-placeholder {
		color: #404040;
	}
	.form-control::-ms-input-placeholder {
		color: #404040;
	}
	.form-group.is-invalid .invalid-feedback {
		display: block;
	}
	#formWrapper {
		bottom: 0;
		top: unset;
		height: initial;
		margin-top: auto;
		overflow: visible;
		z-index: 1040;
	}
	@media (max-height: 700px) {
		#formWrapper {
			overflow-y: scroll;
	    	padding-top: 50px;
	    	height: 100%;
		}
	}
	#formWrapper .modal-content {
		box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
		border: none;
	}
	#formWrapper .modal-body {
		margin-top: 50px;
	}

	#lead-photo {
		position: absolute;
		top: -50px;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 100px !important;
		height: 100px !important;
	}

	#lead-photo img {
		width: 100px !important;
		height: 100px !important;
		border:  3px solid #FFF;
		border-radius: 50%;
	}
	.text-lead {
		color: #404040;
	}
	button.text-lead:hover {
		color: #232323;
	}
	.btn-lead {
		background-color: #404040;
		color: #fff;
		text-transform: uppercase;
	}
	.btn-lead:hover, .btn-lead:active {
		background-color: #232323;
		color: #FFf;
	}
	.v-slide-enter-active {
	  transition: all 2s ease-in-out;
	}
	.v-slide-enter-from,
	.v-slide-leave-to {
	  max-height: 0;
	  height: 0;
	}
	.v-slide-enter-to,
	.v-slide-leave-from {
	  max-height: 100%;
	  height: auto;
	}

</style>